import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import brandLogo from "../assets/betpilot-brand-07.png";

const FooterSection = styled.footer`
  background-color: var(--background);
  padding: 4rem 5% 2rem;
  border-top: 1px solid var(--border);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Logo = styled.img`
  height: 40px;
  margin-bottom: 1.5rem;
`;

const Tagline = styled.p`
  color: var(--text-secondary);
  font-size: 1.1rem;
  margin-bottom: 3rem;
  max-width: 400px;
`;

const Copyright = styled.div`
  color: var(--text-secondary);
  font-size: 0.9rem;
  border-top: 1px solid var(--border);
  padding-top: 2rem;
  width: 100%;
`;

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <FooterSection>
      <Container>
        <Logo src={brandLogo} alt="Betpilot" />
        <Tagline>{t("footer.tagline")}</Tagline>
        <Copyright>
          {t("footer.copyright", { year: new Date().getFullYear() })}
        </Copyright>
      </Container>
    </FooterSection>
  );
};

